module.exports = __webpack_public_path__ + "static/assets/wired-flat-1249-heart-beat-hover-heart-beat.gif";